import { useProgress } from "@react-three/drei";
import Cookies from "js-cookie";

interface SplashScreenProps {
  isFullscreen: boolean;
  externalProgress?: number;
}

export const SplashScreen = ({
  isFullscreen,
  externalProgress = 0,
}: SplashScreenProps) => {
  const { progress: r3fProgress } = useProgress();
  const progress = r3fProgress > 0 ? r3fProgress : externalProgress;

  const activeSplashScreen = Cookies.get("activeSplashScreen");
  const backgroundImageUrl = activeSplashScreen
    ? `${process.env.REACT_APP_API_URL}/images/splashScreens/${activeSplashScreen}.webp`
    : `${process.env.REACT_APP_API_URL}/images/splashScreens/default.webp`;

  return (
    <div
      className={`splashScreen ${isFullscreen ? "fullscreen" : ""}`}
      style={
        backgroundImageUrl
          ? {
              backgroundImage: `url(${backgroundImageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : undefined
      }
    >
      <div className="splashScreen__progress">
        <div
          className="splashScreen__progress__value"
          style={{
            width: `${progress}%`,
          }}
        />
      </div>
      <div className="splashScreen__board" />
    </div>
  );
};
